<template>
    <div class="card">
        <div class="card-header">
            院校基本信息
        </div>
        <div class="card-body text-danger" v-if="showWarningText">
            院校基本信息不可更改，若发生变更，请联系管理员
        </div>
        <table class="table table-bordered mb-0" v-if="collegeInfo">
            <tbody>
            <tr>
                <th class="text-center align-middle" style="width: 15%">院校名称</th>
                <td class="text-left align-middle" colspan="3">{{collegeInfo.collegeName}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">院校代码</th>
                <td class="text-left align-middle" style="width: 35%">{{collegeInfo.collegeCode}}</td>
                <th class="text-center align-middle" style="width: 15%">院校层次</th>
                <td class="text-left align-middle" style="width: 35%">{{collegeInfo.collegeLevelName}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">所在城市</th>
                <td class="text-left align-middle" style="width: 35%">{{collegeInfo.provinceName}} {{collegeInfo.cityName}}</td>
                <th class="text-center align-middle" style="width: 15%">状态</th>
                <td class="text-left align-middle" style="width: 35%">{{collegeInfo.stateName}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import userApi from "@/utils/api/user";
export default {
    name: "CollegeInfoView",
    props: {
        collegeId: {type: String, required: true},
        showWarningText: {type: Boolean, required: false, default: false},
    },
    data: function () {
        return {
            collegeInfo: {},
        };
    },
    mounted() {
        this.getCollegeInfo();
    },
    methods: {
        getCollegeInfo() {
            userApi.college.getCollegeUserInfoById(this.collegeId).then(res => {
                this.collegeInfo = res.data;
            });
        }
    }
}
</script>

<style scoped>

</style>